/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { memoize } from 'lodash/fp';

import TableListCell from 'app/components/commons/TableListCell';
import TableListHead from 'app/components/commons/TableListHead';
import { setSortField } from 'app/actions/playerListActions';

type Props = {
  playerSelectionTableInfo?: Object,
  onSort: string => void,
  sortDirection?: 'asc' | 'desc',
  sortField?: string
};

const PlayerSelectionTableHeadWrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.color.basis6,
  borderTop: '2px solid',
  borderColor: theme.color.basis5,
  color: theme.color.basis1,
  paddingRight: '3rem',
  borderBottom: '2px solid white'
}));

class PlayerSelectionTableHead extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    playerSelectionTableInfo: undefined,
    sortDirection: undefined,
    sortField: undefined
  };

  handleSort = memoize((field: string) => () => {
    const { onSort } = this.props;
    onSort(field);
  });

  sortDirAttr = (field: string) => {
    const { sortDirection, sortField } = this.props;

    return field === sortField ? sortDirection : undefined;
  };

  render() {
    const { playerSelectionTableInfo } = this.props;

    return (
      <PlayerSelectionTableHeadWrapper>
        <TableListHead>
          {playerSelectionTableInfo &&
            Array.isArray(playerSelectionTableInfo.columns) &&
            playerSelectionTableInfo.columns.map(
              ({ field, initial = false, label, size = 'small', sortable = true }) => (
                <TableListCell
                  initial={initial}
                  key={field}
                  size={size}
                  onClick={sortable ? this.handleSort(field) : undefined}
                  sortDir={sortable ? this.sortDirAttr(field) : undefined}
                >
                  {label}
                </TableListCell>
              )
            )}
        </TableListHead>
      </PlayerSelectionTableHeadWrapper>
    );
  }
}

const connector = connect(
  state => ({
    sortDirection: state.challenge.sortDirection,
    sortField: state.challenge.sortField
  }),
  {
    onSort: setSortField
  }
);

export default connector(PlayerSelectionTableHead);
